import React, { useState } from "react";
import {
    Toolbar,
    IconButton,
    Box,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Typography,
    Divider,
    Modal,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { StyledAppBar } from "../common/styles";
import { useNavigate } from "react-router-dom";
import { SQUARE_PAYMENT_LINK, WEBSITE_URL } from "../../../lib/constants";
import ThankYouDialog from "../modals/ThankDialog";
import SearchModal from "../modals/SearchModal";
import { useMode } from "../../../utils/useMode";
// import UserAuthButton from "../auth/UserAuthButton";

const Navbar = ({ handleTabClick, isShowdown = true }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [isOpen, setIsOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showQrModal, setShowQrModal] = useState(false);
    const [openSearchModal, setOpenSearchModal] = useState(false);
    const navigate = useNavigate();
    // const location = useLocation();
    const mode = useMode();

    React.useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "auto";
    }, [isOpen]);

    const handleToggle = () => setIsOpen(!isOpen);
    const handleModalToggle = () => setShowModal(!showModal);
    const handleQrModalToggle = () => setShowQrModal(!showQrModal);

    // const handleLogoClick = () => {
    // if (mode === "jukebox" || mode === "openmic" || isShowdown === false) {
    //   window.location.href = "https://mindyourmusic.live";
    //   return;
    // }

    // if (location.pathname === "/") {
    //   const homeElement = document.getElementById("home");
    //   if (homeElement) {
    //     homeElement.scrollIntoView({ behavior: "smooth" });
    //   }
    // } else {
    //   navigate("/"); // Redirect to the homepage
    // }
    // };

    const handleNavigateToAdminLogin = () => {
        handleToggle();
        setTimeout(() => {
            navigate("/AdminLogin");
        }, 500);
    };

    const handleNavigateToQuizPage = () => {
        handleToggle();
        setTimeout(() => {
            navigate("/quiz");
        }, 500);
    };

    const handleNavigateToMindYourMusicPage = () => {
        handleToggle();
        setTimeout(() => {
            navigate("/mindYourMusic");
        }, 500);
    };

    const handleNavigateToFlashQuizPage = () => {
        handleToggle();
        setTimeout(() => {
            navigate("/quiz?quizMode=flash");
        }, 500);
    };

 

    return (
        <StyledAppBar position="fixed">
            <Toolbar
                sx={{
                    height: { xs: "80px", sm: "100px", md: "120px" },
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "rgba(41, 32, 14, 0.95)",
                    backdropFilter: "blur(10px)",
                    px: { xs: 1, sm: 2, md: 3 },
                }}
            >
                {/* Logo */}
                <Box
                    sx={{ 
                        display: "flex", 
                        alignItems: "center", 
                        cursor: "pointer",
                        flex: { xs: 1, md: 0 }
                    }}
                >
                    {
                        mode === "jukebox" || mode === "openmic" || isShowdown === false ? 
                            <img 
                                src="/mind_your_music.png" 
                                alt="mym Logo" 
                                style={{ 
                                    height: isMobile ? "70px" : "110px",
                                    maxWidth: "100%",
                                    objectFit: "contain"
                                }} 
                            /> :
                            <img 
                                src="/white_logo.png" 
                                alt="IM Logo" 
                                style={{ 
                                    height: isMobile ? "30px" : "40px",
                                    maxWidth: "100%",
                                    objectFit: "contain"
                                }} 
                            />
                    }
                </Box>

                {/* Right Side - Search, Contact, Auth, Menu */}
                {
                    isShowdown && (
                        <Box sx={{ 
                            display: "flex", 
                            alignItems: "center", 
                            gap: { xs: 0.5, sm: 1 },
                            flex: { xs: 0, md: 0 }
                        }}>
                            {/* User Auth Button - Show on desktop, hide on mobile (will be in drawer) */}
                            {/* {!isMobile && (
                                <Box sx={{ mr: 1 }}>
                                    <UserAuthButton />
                                </Box>
                            )} */}

                            <IconButton 
                                color="inherit" 
                                onClick={() => setOpenSearchModal(true)}
                                sx={{
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 255, 255, 0.1)',
                                        transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="1.2em"
                                    height="1.2em"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="currentColor"
                                        d="m18.031 16.617l4.283 4.282l-1.415 1.415l-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9s9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617m-2.006-.742A6.98 6.98 0 0 0 18 11c0-3.867-3.133-7-7-7s-7 3.133-7 7s3.133 7 7 7a6.98 6.98 0 0 0 4.875-1.975z"
                                    />
                                </svg>
                            </IconButton>
                            <SearchModal
                                Modal
                                open={openSearchModal}
                                onClose={() => setOpenSearchModal(false)}
                            />
                            
                            <IconButton 
                                color="inherit" 
                                onClick={() => setShowModal(true)}
                                sx={{
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 255, 255, 0.1)',
                                        transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="1.2em"
                                    height="1.2em"
                                    viewBox="0 0 24 24"
                                >
                                    <g
                                        fill="none"
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                    >
                                        <path d="M17 4v1.882c0 .685.387 1.312 1 1.618s1 .933 1 1.618V18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V9.118c0-.685.387-1.312 1-1.618s1-.933 1-1.618V4M6 4h12z" />
                                        <path d="M14 10h-1a2 2 0 0 0-2 2v2c0 1.105-.395 2-1.5 2H14m-4-3h3" />
                                    </g>
                                </svg>
                            </IconButton>

                            <IconButton 
                                color="inherit" 
                                onClick={handleToggle}
                                sx={{
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 255, 255, 0.1)',
                                        transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <MenuIcon fontSize={isMobile ? "1.5em" : "1.8em"} />
                            </IconButton>
                        </Box>
                    )
                }
            </Toolbar>
            <Drawer
                anchor="right"
                open={isOpen}
                onClose={handleToggle}
                sx={{
                    "& .MuiDrawer-paper": {
                        width: { xs: 280, sm: 320 },
                        padding: 2,
                        bgcolor: '#1A1A1A',
                        color: '#fff',
                    },
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    {
                        mode === "jukebox" || mode === "openmic" ? 
                            <img src="/mind_your_music.png" alt="mym Logo" style={{ height: "70px" }} /> :
                            <img src="/white_logo.png" alt="IM Logo" style={{ height: "35px" }} />
                    }
                    <IconButton 
                        onClick={handleToggle}
                        sx={{ color: '#fff' }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* User Auth Button in Mobile Drawer */}
                {/* <Box sx={{ mb: 2, px: 1 }}>
                    <UserAuthButton />
                </Box> */}

                <Divider sx={{ my: 2, bgcolor: 'rgba(255, 255, 255, 0.2)' }} />

                {/* Sidebar Options */}
                <List>
                    <ListItem
                        sx={{
                            textDecoration: "none",
                            color: "inherit",
                            display: "flex",
                            justifyContent: "flex-start",
                            cursor: "pointer",
                            borderRadius: '8px',
                            mb: 0.5,
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.1)',
                            },
                            transition: 'all 0.2s ease'
                        }}
                        onClick={() => {
                            handleToggle();
                            handleTabClick("playlists");
                        }}
                    >
                        <ListItemText 
                            primary="Playlists" 
                            primaryTypographyProps={{
                                sx: { 
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }
                            }}
                        />
                    </ListItem>

                    <ListItem
                        component="a"
                        href={SQUARE_PAYMENT_LINK}
                        sx={{
                            textDecoration: "none",
                            color: "inherit",
                            borderRadius: '8px',
                            mb: 0.5,
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.1)',
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <ListItemText 
                            primary="Tip Jar" 
                            primaryTypographyProps={{
                                sx: { 
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }
                            }}
                        />
                    </ListItem>
                    <ListItem
                        component="a"
                        href={SQUARE_PAYMENT_LINK}
                        sx={{
                            textDecoration: "none",
                            color: "inherit",
                            borderRadius: '8px',
                            mb: 0.5,
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.1)',
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <ListItemText 
                            primary="Donation" 
                            primaryTypographyProps={{
                                sx: { 
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }
                            }}
                        />
                    </ListItem>

                    <ListItem 
                        button 
                        onClick={handleQrModalToggle}
                        sx={{
                            borderRadius: '8px',
                            mb: 0.5,
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.1)',
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <ListItemText 
                            primary="Payment Code" 
                            primaryTypographyProps={{
                                sx: { 
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }
                            }}
                        />
                    </ListItem>

                    {
                        (mode !== "jukebox" && mode !== "openmic") && (
                            <ListItem
                                component="a"
                                href={WEBSITE_URL}
                                target="_blank"
                                rel="noreferrer"
                                sx={{
                                    textDecoration: "none",
                                    color: "inherit",
                                    borderRadius: '8px',
                                    mb: 0.5,
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 255, 255, 0.1)',
                                    },
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <ListItemText 
                                    primary="Website" 
                                    primaryTypographyProps={{
                                        sx: { 
                                            fontSize: '1rem',
                                            fontWeight: 500
                                        }
                                    }}
                                />
                            </ListItem>
                        )
                    }

                    <ListItem 
                        button 
                        onClick={handleModalToggle}
                        sx={{
                            borderRadius: '8px',
                            mb: 0.5,
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.1)',
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <ListItemText 
                            primary="Contact" 
                            primaryTypographyProps={{
                                sx: { 
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }
                            }}
                        />
                    </ListItem>

                    <ListItem 
                        button 
                        onClick={handleNavigateToQuizPage}
                        sx={{
                            borderRadius: '8px',
                            mb: 0.5,
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.1)',
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <ListItemText 
                            primary="Quiz" 
                            primaryTypographyProps={{
                                sx: { 
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }
                            }}
                        />
                    </ListItem>
                    
                    <ListItem 
                        button 
                        onClick={handleNavigateToFlashQuizPage}
                        sx={{
                            borderRadius: '8px',
                            mb: 0.5,
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.1)',
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <ListItemText 
                            primary="Flash Quiz" 
                            primaryTypographyProps={{
                                sx: { 
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }
                            }}
                        />
                    </ListItem>

                    <ListItem 
                        button 
                        onClick={handleNavigateToMindYourMusicPage}
                        sx={{
                            borderRadius: '8px',
                            mb: 0.5,
                            '&:hover': {
                                bgcolor: 'rgba(255, 255, 255, 0.1)',
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <ListItemText 
                            primary="Mind Your Music" 
                            primaryTypographyProps={{
                                sx: { 
                                    fontSize: '1rem',
                                    fontWeight: 500
                                }
                            }}
                        />
                    </ListItem>

                    {
                        (mode !== "jukebox" && mode !== "openmic") && (
                            <ListItem
                                onClick={() => {
                                    handleNavigateToAdminLogin()
                                }}
                                sx={{ 
                                    cursor: "pointer",
                                    borderRadius: '8px',
                                    mb: 0.5,
                                    '&:hover': {
                                        bgcolor: 'rgba(255, 255, 255, 0.1)',
                                    },
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <ListItemText 
                                    primary="Admin Login" 
                                    primaryTypographyProps={{
                                        sx: { 
                                            fontSize: '1rem',
                                            fontWeight: 500
                                        }
                                    }}
                                />
                            </ListItem>
                        )}
                </List>
            </Drawer>

            {/* Backdrop */}
            {isOpen && (
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        bgcolor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 1200,
                    }}
                />
            )}
            <Modal open={showQrModal} onClose={handleQrModalToggle}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "#1E1E1E",
                        py: 4,
                        px: 2,
                        borderRadius: 2,
                        boxShadow: 24,
                        textAlign: "center",
                        maxWidth: "80%",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            mt: -2,
                        }}
                    >
                        <Typography variant="h6" noWrap>
                            Payment Code
                        </Typography>
                        <IconButton onClick={handleQrModalToggle}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <img
                        src="/assets/QR.png"
                        alt="QR Code"
                        style={{ margin: "20px 0", width: "150px", height: "150px" }}
                    />
                    <Typography>Scan this code to make a payment</Typography>
                </Box>
            </Modal>
            <ThankYouDialog
                from="navBar"
                open={showModal}
                onClose={() => setShowModal(false)}
            />
        </StyledAppBar>
    );
};

export default Navbar;
